/** 자동 후속 턴 훅 — 판정은 `decideFollowUp`(순수), 여기는 구독·부수효과만. */
import { useEffect, useRef, useState } from 'react'

import { useChatStore } from '@/chat/store'
import { decideFollowUp } from './autoFollowUp'
import type { JobView } from './types'

export function useAutoFollowUp(job: JobView | null | undefined): void {
  const status = useChatStore((s) => s.status)
  const send = useChatStore((s) => s.send)
  const fired = useRef<Set<string>>(new Set())
  const [visible, setVisible] = useState(
    () => typeof document === 'undefined' || document.visibilityState === 'visible',
  )

  // 탭 복귀를 신호로 받는다 — 숨겨진 동안 완료된 job 은 돌아온 시점에 이어 말한다.
  useEffect(() => {
    const onChange = () => setVisible(document.visibilityState === 'visible')
    document.addEventListener('visibilitychange', onChange)
    return () => document.removeEventListener('visibilitychange', onChange)
  }, [])

  useEffect(() => {
    const decision = decideFollowUp({
      job,
      done: fired.current,
      streaming: status === 'streaming',
      visible,
    })
    if (!decision.fire) return
    // 발사 전에 표시한다 — await 사이에 폴링이 한 번 더 돌아도 두 번 던지지 않게.
    fired.current.add(decision.jobId)
    void send(decision.prompt)
  }, [job, status, visible, send])
}
